module.exports = __webpack_public_path__ + "img/spicy.276d80c8.svg";